import React, { useState, useEffect, useRef } from 'react';
import './App.css'; // Додаємо стилі для кращого вигляду

function App() {
  const [data, setData] = useState(null);
  const [counts, setCounts] = useState({});
  const [input, setInput] = useState('');
  const [error, setError] = useState(''); // Стан для повідомлення про помилку
  const [delay, setDelay] = useState(500); // Затримка за замовчуванням 0.5 секунди (500 мс)
  const inputRef = useRef(null); // Референс для input

  // Завантаження даних з API
  useEffect(() => {
    fetch('https://1c.officemix.keenetic.pro/omdriver/hs/1c/npttn')
      .then(res => res.json())
      .then(json => {
        setData(json);
        const initialCounts = {};
        json.ttns.forEach(item => {
          initialCounts[item.ttn] = 0;
        });
        setCounts(initialCounts);
      })
      .catch(error => {
        console.error('Помилка завантаження даних:', error);
        setError('Помилка завантаження даних. Спробуйте ще раз.');
      });
  }, []);

  // Автофокус на полі введення після рендерингу
  useEffect(() => {
    if (inputRef.current) {
      inputRef.current.focus();
    }
  }, []);

  // Очищення повідомлення про помилку через 5 секунд
  useEffect(() => {
    if (error) {
      const timer = setTimeout(() => setError(''), 5000);
      return () => clearTimeout(timer);
    }
  }, [error]);

  // Автопошук з затримкою (debounce)
  useEffect(() => {
    if (input.trim().length < 14) return;

    const timer = setTimeout(() => {
      performSearch();
    }, delay);

    return () => clearTimeout(timer);
  }, [input, delay]);

  const handleInputChange = (e) => {
    setInput(e.target.value);
  };

  const handleDelayChange = (e) => {
    setDelay(parseInt(e.target.value, 10));
  };

  const performSearch = () => {
    const trimmedInput = input.trim();
    const searchInput = trimmedInput.slice(0, 14); // Беремо перші 14 символів

    if (searchInput.length < 14) {
      setError('ПОМИЛКА: Введено менше 14 символів. Будь ласка, введіть повний номер TTN.');
      return;
    }

    const item = data?.ttns.find(i => i.ttn === searchInput);
    if (!item) {
      setError('ПОМИЛКА: даної ТТН немає в списку створених ТТН.');
    } else if (counts[searchInput] >= item.seats) {
      setError('ПОПЕРЕДЖЕННЯ: для даної ТТН вже відмічені всі доступні місця. Перевірте, правильність введення даних.');
    } else {
      setCounts(prev => ({ ...prev, [searchInput]: prev[searchInput] + 1 }));
      setError(''); // Очищаємо помилку при успішному введенні
    }

    setInput('');
    if (inputRef.current) {
      inputRef.current.focus(); // Повертаємо фокус
    }
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    if (input.trim()) {
      performSearch(); // Негайний пошук при натисканні кнопки
    }
  };

  const resetCount = (ttn) => {
    setCounts(prev => ({ ...prev, [ttn]: 0 }));
    if (inputRef.current) {
      inputRef.current.focus(); // Повертаємо фокус після скидання
    }
  };

  const getIcon = (type) => {
    if (type === 'delivery') return '🚚';
    if (type === 'documents') return '📄';
    return '❓';
  };

  // Відображаємо "Завантаження..." або помилку, якщо дані ще не завантажилися
  if (!data) {
    return (
      <div className="container">
        {error ? <div className="error-message">{error}</div> : <div>Завантаження...</div>}
      </div>
    );
  }

  return (
    <div className="container">
      <div className="header">
        <div className="date">{data.date}</div>
        <form onSubmit={handleSubmit} className="input-form">
          <select
            value={delay}
            onChange={handleDelayChange}
            className="delay-select"
          >
            <option value={500}>0.5 секунди</option>
            <option value={1000}>1 секунда</option>
            <option value={1500}>1.5 секунди</option>
          </select>
          <input
            type="text"
            value={input}
            onChange={handleInputChange}
            placeholder="Введіть номер TTN"
            className="ttn-input"
            ref={inputRef} // Додаємо референс до input
          />
          <button type="submit" className="submit-button">Підтвердити</button>
        </form>
      </div>
      {error && <div className="error-message">{error}</div>}
      <div className="ttn-list">
        {data.ttns.map(item => {
          const count = counts[item.ttn] || 0;
          const isFull = count >= item.seats;
          return (
            <div
              key={item.ttn}
              className={`ttn-item ${isFull ? 'full' : ''}`}
            >
              <span className="icon">{getIcon(item.type)}</span>
              <span className="ttn">{item.ttn}</span>
              <span className="seats">{count}/{item.seats}</span>
              <button
                onClick={() => resetCount(item.ttn)}
                className="reset-button"
              >
                &times;
              </button>
            </div>
          );
        })}
      </div>
    </div>
  );
}

export default App;